import React, { useState, useEffect, } from 'react'
import { Helmet, } from "react-helmet"
import { appDescription, appName, webApiRootURL } from '../../../constants'
import Loading from '../../layouts/Loading'
import { useSelector, useDispatch, } from 'react-redux'
import { getDownloadAccess } from '../../../redux/actions/getDownloadAccessActions'
import moment from 'moment'

export default function LosMuertosDownloadComponent() {
  const [loading, setLoading] = useState(true)
  const state = useSelector(state => ({
    auth: state.auth,
    getDownloadAccess: state.getDownloadAccess,
  }))
  const dispatch = useDispatch()
  const [message, setMessage] = useState("")

  useEffect(() => {
    dispatch(getDownloadAccess())
  }, [])

  useEffect(() => {
    if (!state.auth.loading && !state.getDownloadAccess.loading) {
      if (state.auth.data && state.getDownloadAccess.data) {
        if (false === state.auth.data.isAdmin) {
          // Get temporary resource access for the
          // user and check if they have access to this
          // resource. If not, redirect to home page.
          if (
            Object.keys(state.getDownloadAccess.data).includes("los-muertos-game") &&
            false !== state.getDownloadAccess.data["los-muertos-game"] &&
            moment().isBefore(moment(state.getDownloadAccess.data["los-muertos-game"].expiresAt))
          ) {
            setLoading(false)
            setMessage(
              "You have access to download this resource until " + moment(state.getDownloadAccess.data["los-muertos-game"].expiresAt).format("MMMM Do YYYY, hh:mm")
            )
          } else {
            // No access.
            window.location.href = "/"
          }
        } else {
          // Is admin user.
          setMessage("You are an admin user so you have access to this resource.")
          setLoading(false)
        }
      } else if (state.getDownloadAccess.error) {
        window.location.href = "/"
      } else {
        setLoading(false)
      }
    }
  }, [state.auth, state.getDownloadAccess])

  if (loading || state.auth.loading || state.getDownloadAccess.loading) {
    return <>
      <Helmet>
        <title>Download Los Muertos Game - {appName}</title>
        <meta name="title" content={`Download Los Muertos Game - ${appName}`}/>
        <meta name="description" content={appDescription}/>
      </Helmet>
      <div className="text-center mt-9 mb-8">
        <Loading />
      </div>
    </>
  }

  return (
    <>
      <Helmet>
        <title>Download Los Muertos Game - {appName}</title>
        <meta name="title" content={`Download Los Muertos Game - ${appName}`}/>
        <meta name="description" content={appDescription}/>
      </Helmet>
      <section className="py-7 py-lg-10">
        <div className="container">
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <h3 className='mb-5'>Download Los Muertos Game</h3>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 offset-md-4">
              {message && <p className="mb-4">{message}</p>}

              <a
                target="_blank"
                href={`${webApiRootURL}/binaries/LosMuertosWindows.zip`}
                className="btn btn-primary joystick-btn"
              >
                Download For Windows
              </a>
              <br />
              <a
                target="_blank"
                href={`${webApiRootURL}/binaries/LosMuertosMac.zip`}
                className="btn btn-primary joystick-btn mt-3"
              >
                Download For Mac
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
